import axios from 'axios';
import { GatsbyImage } from 'gatsby-plugin-image';
import React, { useCallback, useEffect, useState } from 'react';
import imgFallback from 'src/utils/image';

let ElementLottie;
if (typeof window !== 'undefined') {
  ElementLottie = React.lazy(() => import('src/components/ElementLottie/ElementLottie'));
}

export const useLottieAnimation = ({ animationData, fallbackImage }) => {
  const [animationJson, setAnimationJson] = useState(null);

  const animationDataUrl = animationData?.asset?.url;

  useEffect(() => {
    (async () => {
      if (animationDataUrl === undefined) {
        return;
      }

      const data = await axios.get(animationDataUrl);
      const json = await data.data;
      setAnimationJson(json);
    })();
  }, [animationDataUrl]);

  const Fallback = useCallback(
    () => (
      <GatsbyImage loading="eager" alt={fallbackImage?.alt ?? ''} image={fallbackImage?.image?.asset?.gatsbyImageData ?? imgFallback} />
    ),
    [fallbackImage]
  );

  const Animation = useCallback(() => {
    if (ElementLottie) {
      return (
        <React.Suspense fallback={<Fallback />}>
          {animationJson ? <ElementLottie animationData={animationJson} /> : <Fallback />}
        </React.Suspense>
      );
    }
    return <Fallback />;
  }, [animationJson]);

  return { Animation, FallbackImage: Fallback };
};
